/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "transaction-history",
	props:{
		companyId: {
			default: null
		}
	},
	data() {
		return {
			customerTransactionHistory: [],
			customerTransactionHistoryHeadings: [
				{
					text: "Transaction Date",
					field: "insertedOn"
				
				},
				// {
				// 	text: "Transaction Type",
				// 	field: "transactionType"
				// },
				{
					text: "Transaction Details",
					field: "comment"
				},
				{
					text: "Added/Deducted",
					field: "amountAsString"
				},
				{
					text: "Balance",
					field: "currentBalanceAsString"
				}
			],
			customer: {},
			currentBalance: 0,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			loadCreditsFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "loadCreditsModal",
				heading: "Load Customer Credits",
				loadCredits:{
					amountToLoad: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					comments: null
				}
			},
			reduceCreditsFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "reduceCreditsModal",
				heading: "Reduce Customer Credits",
				isActive: null,
				reduceCredits:{
					amountToReduce: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					comments: null
				}
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getCustomer(){
			let request = {
				companyId: this.companyId
			};
			customerService.getCompany(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.customer = successResponse.data.result;
						this.setBreadcrumbs();
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getTransactionHistory(){
			this.loading = true;
			let request = {
				companyId: this.companyId,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				fromDateCreated: this.filter.fromDateCreated,
				toDateCreated: this.filter.toDateCreated,
				searchQuery: this.filter.customerSearchQuery
			};
			customerCreditsService.getCompanyCreditHistoryByCompany(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.customerTransactionHistory = successResponse.data.result;
						this.filterStateChanged = false;
						this.customerTransactionHistory = dataTableHelper.castFieldValues(this.customerTransactionHistory);
						for(var i = 0; i < this.customerTransactionHistory.length; i++){
							this.customerTransactionHistory[i].amountAsString = currencyHelper.numberToCurrency(this.customerTransactionHistory[i].amount);
							this.customerTransactionHistory[i].currentBalanceAsString = currencyHelper.numberToCurrency(this.customerTransactionHistory[i].currentBalance);
						}
					}
					permissionsHelper.setControlsBasedOnPermissions();
					this.loading = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loading = false;
				}
			);
		},
		getCurrentBalance(){
			customerCreditsService.getCurrentCompanyCreditByCompany(this.companyId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.result === null){
							this.currentBalance = currencyHelper.numberToCurrency(0);
						}
						else{
							this.currentBalance = currencyHelper.numberToCurrency(successResponse.data.result.currentBalance);
						}
					}
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			//TODO: filter customer results
			this.getTransactionHistory();
		},
		onDateFilterClearClick(){
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			this.filterStateChanged = true;
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onLoadCreditsClick(){
			this.loadCreditsFormModal.showModal = true;
		},
		onReduceCreditsClick(){
			this.reduceCreditsFormModal.showModal = true;
		},
		onLoadCreditsCloseClick(){
			this.loadCreditsFormModal.showModal = false;
		},
		onReduceCreditsCloseClick(){
			this.reduceCreditsFormModal.showModal = false;
		},
		onReduceCreditsModalSaveButtonClicked(){
			this.reduceCreditsFormModal.isSaving = true;
			let request = {
				companyId: this.companyId,
				amountToReduce: this.reduceCreditsFormModal.reduceCredits.amountToReduce.value,
				comments: this.reduceCreditsFormModal.reduceCredits.comments
			};
			customerCreditsService.reduceCompanyCredits(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.customerCreditsValidationResponse.valuesAreValid) {
							this.clearReduceCreditsModel();
							this.getCurrentBalance();
							this.getTransactionHistory();
							this.reduceCreditsFormModal.showModal = false;
						}
						else{
							this.reduceCreditsFormModal.reduceCredits.amountToReduce.hasError = successResponse.data.customerCreditsValidationResponse.amountValidationResponse.hasError;
							this.reduceCreditsFormModal.reduceCredits.amountToReduce.errorMessage = successResponse.data.customerCreditsValidationResponse.amountValidationResponse.message;
						}
					}
					this.reduceCreditsFormModal.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.reduceCreditsFormModal.isSaving = false;
				}
			);
		},
		clearReduceCreditsModel()
		{
			this.reduceCreditsFormModal.reduceCredits.amountToReduce.value = null;
			this.reduceCreditsFormModal.reduceCredits.comments = null;
		},
		onLoadCreditsModalSaveButtonClicked(){
			this.loadCreditsFormModal.isSaving = true;
			let request = {
				companyId: this.companyId,
				amountToLoad: this.loadCreditsFormModal.loadCredits.amountToLoad.value,
				comments: this.loadCreditsFormModal.loadCredits.comments
			};
			customerCreditsService.loadCompanyCredits(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.customerCreditsValidationResponse.valuesAreValid) {
							this.clearLoadCreditsModel();
							this.getCurrentBalance();
							this.getTransactionHistory();
							this.loadCreditsFormModal.showModal = false;
						}
						else{
							this.loadCreditsFormModal.loadCredits.amountToLoad.hasError = successResponse.data.customerCreditsValidationResponse.amountValidationResponse.hasError;
							this.loadCreditsFormModal.loadCredits.amountToLoad.errorMessage = successResponse.data.customerCreditsValidationResponse.amountValidationResponse.message;
						}
					}
					this.loadCreditsFormModal.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loadCreditsFormModal.isSaving = false;
				}
			);
		},
		onFormModalSaveButtonClicked(){
			//save
			this.customerAddEditFormModal.isSaving = true;
			var self = this;
			setTimeout(function(){
				self.customerAddEditFormModal.isSaving = false;
				self.customerAddEditFormModal.showModal = false;
				console.log("customer", self.customer);
			}, 2000);
		},
		clearLoadCreditsModel(){
			this.loadCreditsFormModal.loadCredits.amountToLoad.value = null;
			this.loadCreditsFormModal.loadCredits.comments = null;
		},
		setBreadcrumbs() {
			var pageTitle = "Transaction History - " + this.customer.registeredCompanyName;
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
	},
	watch: {
		companyId: {
			handler: function () {
				if (this.companyId !== null && this.companyId > 0) {
					this.getTransactionHistory();
					this.getCurrentBalance();
					this.getCustomer();
				}
			},
			immediate: true,
			deep: true
		}
	}
};